<template>
  <d-card>
    <v-form
      ref="form"
      :data="form"
      :url="endpoint.url"
      :method="endpoint.method"
      @success="$router.push('/properties/'+$route.params.property+'/application-files')"
    >
      <template #default="{ errors }">
        <d-card-row>
          <v-input-date
            v-model="form.lease_term_start_date"
            required
            name="lease_term_start_date"
            :label="$t('lease_term_start_date')"
          />
        </d-card-row>

        <d-card-row>
          <v-input-date
            v-model="form.lease_term_end_date"
            required
            name="lease_term_end_date"
            :label="$t('lease_term_end_date')"
            has-info
            info-size="is-large"
            info-type="html"
          >
            <template
              #info
            >
              <div v-if="property && property.latest_status.possible_lease_duration && property.latest_status.possible_lease_duration.length">
                <p
                  v-for="(item, index) in property.latest_status.possible_lease_duration"
                  :key="index"
                >
                  {{ item.label }}
                </p>
              </div>
            </template>
          </v-input-date>
        </d-card-row>

        <d-card-row>
          <v-input
            v-model="form.rent"
            type="number"
            required
            name="rent"
            :label="$t('rent')"
            :placeholder="$t('rent')"
          />
        </d-card-row>

        <d-card-row>
          <v-input-switch
            v-model="form.heating_included"
            :true-value="true"
            :false-value="false"
            name="heating_included"
            :label="$t('heating_included')"
          />
        </d-card-row>

        <d-card-row>
          <v-input-switch
            v-model="form.lighting_included"
            :true-value="true"
            :false-value="false"
            name="lighting_included"
            :label="$t('lighting_included')"
          />
        </d-card-row>

        <d-card-row v-if="action === 'create'">
          <h3 class="title is-5">
            {{ $t('applicants') }}
          </h3>
          <div class="mt-2">
            <v-applicant-form
              :applicants="form.applicants"
              :errors="errors"
              @update="onUpdateApplicant"
            />
          </div>
        </d-card-row>

        <d-card-row>
          <button
            class="button is-primary"
            type="submit"
          >
            {{ $t('save') }}
          </button>
        </d-card-row>
      </template>
    </v-form>
  </d-card>
</template>

<script>
import { fillFields } from "@/services/helpers";
import ApplicantForm from "./components/ApplicantForm.vue";

export default {
  components: {
    "v-applicant-form": ApplicantForm,
  },
  props: {
    action: {
      type: String,
      required: true
    },
    model: {
      default: null,
      type: Object
    },
    property: {
      default: null,
      type: Object
    }
  },
  data () {
    return {
      form: {
        name: "",
        property_id: this.$route.params.property,
        lease_term_start_date: null,
        lease_term_end_date: null,
        rent: null,
        heating_included: false,
        lighting_included: false,
        applicants: []
      }
    };
  },
  computed: {
    endpoint () {
      if (this.action === "create") {
        return {
          method: "post",
          url: this.$laravel.route("api.application-files.store", {
            property: this.$route.params.property
          })
        };
      }
      if (this.action === "edit") {
        return {
          method: "patch",
          url: this.$laravel.route("api.application-files.update", {
            property: this.$route.params.property,
            application_file: this.model.id
          })
        };
      }
      return null;
    },
  },
  created () {
    if (this.action === "edit") {
      this.form = fillFields(this.form, this.model);
    }

    if (this.action === "create") {

      if (this.property && this.property.latest_status) {
        this.form.rent = this.property.latest_status.asked_rent;

        if (this.property.latest_status && this.property.latest_status.is_occupied) {
          this.form.lease_term_start_date = this.property.latest_status.availability_date;
        }

        if (this.property.inclusions && this.property.inclusions.length) {


          const heating =  this.property.inclusions.filter(inclusion => inclusion.inclusion === "heater");

          const lighting = this.property.inclusions.filter(inclusion => inclusion.inclusion === "electricity");

          if (heating && heating.length) {
            this.form.heating_included = heating[0].status;
          }

          if (lighting && lighting.length) {
            this.form.lighting_included = lighting[0].status;
          }

        }
      }

      this.form.applicants.push({
        first_name: "",
        last_name: "",
        email: "",
        applicant_type: null,
        locale: null,
      });
    }
  },
  methods: {
    onUpdateApplicant(applicants) {
      this.form.applicants = applicants;
    }
  }
};
</script>
